import React, { lazy, Suspense } from "react"

import { useAccount } from "@shared/contexts"

import LoadingApp from "LoadingApp"
import {RecoilRoot} from "recoil";

const ProtectApp = lazy(
  () => import(/* webpackPrefetch: true */ "./ProtectApp"),
)

function App() {
  const { account } = useAccount()

  const isSigned = account.viewer ? true : false

  return (
    <RecoilRoot>
      <Suspense fallback={<LoadingApp />}>
        {isSigned ? <ProtectApp /> : <LoadingApp />}
      </Suspense>
    </RecoilRoot>
  )
}

export default App
